import { render, staticRenderFns } from "./FloatingAiChatLauncher.vue?vue&type=template&id=3a6bd963&scoped=true"
import script from "./FloatingAiChatLauncher.vue?vue&type=script&lang=js"
export * from "./FloatingAiChatLauncher.vue?vue&type=script&lang=js"
import style0 from "./FloatingAiChatLauncher.vue?vue&type=style&index=0&id=3a6bd963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bd963",
  null
  
)

export default component.exports